// extracted by mini-css-extract-plugin
module.exports = {"container":"_1MA5xQPc1_RhwlGK8FX3Fz","text-container":"_14VWLdJhjIqXe7FLynznd7"};